const driver_license =`Having a drivers license is important for everyone.
In finland like many other countries gives license at the age of 18.
Personally I believe its a good age to acquire license, 
since it helps us to drive a car and move around freely.
Its same in my country too, you get a driver's license when you are 18.
Instead of an upper age limit we could cancel the license, 
when a person's health no longer allows him to drive safely.
Driving test are simpler than finland and also costs less.
To get a driver's license, you need to learn about the rules of the road and how to drive safely.
To make things better, we can change how people get their driver's licenses. 
We could have some new devices installed on a user's car and monitor how they are performing on the road.
Based on that we can decide if the license needs to be revoked.
This can help make our roads safer for everyone.`;

export default driver_license;